import React from 'react'
import FinalizationContainer from './FinalizationContainer'

const Finalization = props => (
  <FinalizationContainer {...props} data-test="component-finalization" />
)

export default Finalization
